import type { TourDef } from './index';

const a = (id: string): string => `[data-tour="${id}"]`;

export const homeTour: TourDef = {
  id: 'home',
  steps: [
    { element: a('net-worth'), popover: { title: 'Your net worth', description: 'Everything you own minus everything you owe, with the change over the last 30 days.' } },
    { element: a('safe-to-spend'), popover: { title: 'Safe to spend', description: "What's left this period after bills, budgets and goal contributions. Tap it to see the working." } },
    { element: a('goals'), popover: { title: 'Goals', description: 'Rings fill as you get closer. Milestones at 25, 50, 75, 90 and 100 % get a small celebration.' } },
    { element: a('checkin-card'), popover: { title: 'Daily check-in', description: 'About a minute: confirm new transactions so your numbers stay right.' } },
    { element: a('search'), popover: { title: 'Jump anywhere', description: 'Press ⌘K (Ctrl K) to search transactions, run actions or switch entity.' } },
    { element: a('help-button'), popover: { title: 'Help on every page', description: 'Press ? for help about the screen you are on. You can replay this tour from there.' } },
  ],
};
